import { useEffect, useState } from 'react';
import { Space, Input, Button, Row, Col, Pagination } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import './index.scss';
import classnames from 'classnames';
import bgc1 from "@/assets/images/community/banner-compress.png";
import { allCourse } from "@/apis/course";
import { useNavigate } from 'react-router-dom';
import intl from 'react-intl-universal';

const CourceHub = () => {
	const [params, setParams] = useState({})
	const [total, setTotal] = useState(0)
	const navigate = useNavigate()
	// const [banner, setBanner] = useState([])
	const [pageParams, setPageParams] = useState({
		currentPage: 1,
		pageSize: 6
	})
	const [list, setList] = useState([])
	const getList = () => {
		allCourse({
			...params,
			...pageParams
		}).then(res => {
			setList(res.data?.records || [])
			setTotal(res.data?.total || 0)
		}).catch(err => { })
	}

	// const getBanner = () => {
	// 	allCourse({
	// 		pageParam: { currentPage: 1, pageSize: 3 }
	// 	}).then(res => {
	// 		const arr = (res.data?.records || []).map(item => {
	// 			return {
	// 				path: item?.coverImage?.filePath
	// 			}
	// 		})
	// 		setBanner(arr)
	// 	}).catch(err => { })
	// }

	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			handelQuery()
		}
	}

	const handelQuery = () => {
		setPageParams({
			currentPage: 1,
			pageSize: pageParams.pageSize
		})
	}

	const goDetail = (id) => {
		navigate(`/discover/course-detail?id=${id}`);
		window.scrollTo(0, 0)
	}
	// useEffect(() => {
	// 	getBanner()
	// }, [])

	useEffect(() => {
		getList()
	}, [pageParams])

	return <div className={styles.courceHubBox}>
		{/* <Carousel arrows={true} dot={false} autoplay >
			{banner.map(item => {
				return <div className={styles.carouselBox} key={item.path}>
					<img src={process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + item.path} />
				</div>
			})}
		</Carousel> */}

		<div className={classnames('container', styles.contentBox)}>
			<h3>{intl.get("Course.All courses")}</h3>
			<Space.Compact size="large" style={{ width: '100%' }}>
				<Input
					allowClear
					placeholder={intl.get("Course.Title Of Course")}
					onKeyDown={handleKeyDown}
					onChange={(e) => {
						setParams({ keywords: e.target.value })
					}} />
				<Button type="primary" onClick={handelQuery}>{intl.get("Search")}</Button>
			</Space.Compact>

			<Row gutter={20} >
				{list.map((item, index) => {
					return <Col span={6} key={item.courseUuid}>
						<div className={styles.colBox} onClick={() => goDetail(item.courseUuid)}>
							<div className={styles.imgBox}>
								<img src={item.coverImage ? process.env.REACT_APP_API_AFFIX + "/file/preview?filePath=" + item.coverImage.filePath : bgc1} />
							</div>
							<h3 title={item.courseName}>{item.courseName}</h3>
							<p className="flex_box flex_between"><span>{item.teacherName}</span> <span><UserOutlined /> {item.viewTimes}</span></p>
							{/* <div>
								<h3>{item.courseName}</h3>
								<div>{item.teacherName}</div>
								<Button type="primary" size="small">进入课程</Button>
							</div> */}
						</div>
					</Col>
				})}
			</Row>

			<Pagination
				style={{ marginTop: "20px" }}
				align="end"
				current={pageParams.currentPage}
				pageSize={pageParams.pageSize}
				defaultPageSize={6}
				total={total}
				showSizeChanger={false}
				onChange={(page, pageSize) => {
					setPageParams({
						currentPage: page,
						pageSize: pageSize,
					});
				}}
			/>
		</div>

	</div>;
}
export default CourceHub;